"use client";

import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Gallery.css";

import Image1 from "../assets/Image1.jpg";
import Image2 from "../assets/Image2.jpg";
import Image3 from "../assets/Image3.jpg";
import Image4 from "../assets/Image4.jpg";
import Image5 from "../assets/Image5.jpg";
import Image6 from "../assets/Image6.jpg";
import Image7 from "../assets/Image7.jpg";
import Image8 from "../assets/Image8.jpg";
import Image9 from "../assets/Image9.jpg";
import Image10 from "../assets/Image10.jpg";
import Image11 from "../assets/Image11.jpg";
import Image12 from "../assets/Image12.jpg";
import Image13 from "../assets/Image13.jpg";
import Image14 from "../assets/Image14.jpg";
import Image15 from "../assets/Image15.jpg";
import Image16 from "../assets/Image16.jpg";
import Image17 from "../assets/Image17.jpg";
import Image18 from "../assets/Image18.jpg";
import Image19 from "../assets/Image19.jpg";
import Image20 from "../assets/Image20.jpg";
import Image21 from "../assets/Image21.jpg";

const images = [
  { src: Image1, title: "Small Hands Can Change the World - Save Our Earth", date: "2024-03-15", eventType: "environment" },
  { src: Image2, title: "Promoting Environmental Awareness Through Community Action", date: "2024-02-20", eventType: "environment" },
  { src: Image3, title: "Tree Plantation Initiatives for a Greener Tomorrow", date: "2024-01-10", eventType: "environment" },
  { src: Image4, title: "Working Together for Environmental Conservation", date: "2023-12-05", eventType: "environment" },
  { src: Image5, title: "Empowering Communities Through Education", date: "2024-03-01", eventType: "education" },
  { src: Image6, title: "Building Sustainable Futures Together", date: "2024-02-15", eventType: "education" },
  { src: Image7, title: "Creating Positive Environmental Impact", date: "2024-01-25", eventType: "environment" },
  { src: Image8, title: "Fostering Community Development", date: "2023-11-30", eventType: "welfare" },
  { src: Image9, title: "Sports Excellence and Teamwork", date: "2024-03-10", eventType: "sports" },
  { src: Image10, title: "Educational Outreach Programs", date: "2024-02-28", eventType: "education" },
  { src: Image11, title: "Community Health Initiatives", date: "2024-01-20", eventType: "welfare" },
  { src: Image12, title: "Youth Sports Development", date: "2023-12-15", eventType: "sports" },
  { src: Image13, title: "Environmental Awareness Campaigns", date: "2024-03-05", eventType: "environment" },
  { src: Image14, title: "Educational Workshops", date: "2024-02-10", eventType: "education" },
  { src: Image15, title: "Social Welfare Programs", date: "2024-01-15", eventType: "welfare" },
  { src: Image16, title: "Sports Training Sessions", date: "2023-11-25", eventType: "sports" },
  { src: Image17, title: "Community Education Events", date: "2024-03-08", eventType: "education" },
  { src: Image18, title: "Environmental Protection Activities", date: "2024-02-05", eventType: "environment" },
  { src: Image19, title: "Youth Development Programs", date: "2024-01-30", eventType: "welfare" },
  { src: Image20, title: "Sports Competitions", date: "2023-12-20", eventType: "sports" },
  { src: Image21, title: "Educational Support Initiatives", date: "2024-03-12", eventType: "education" },
];

export default function Gallery() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [sortBy, setSortBy] = useState("date");
  const [filterBy, setFilterBy] = useState("all");

  const carouselImages = images.slice(0, 8);

  const sortedImages = useMemo(() => {
    const filteredImages =
      filterBy === "all" ? images : images.filter((image) => image.eventType === filterBy);

    return [...filteredImages].sort((a, b) => {
      if (sortBy === "title") {
        return a.title.localeCompare(b.title);
      }

      if (sortBy === "eventType") {
        return a.eventType.localeCompare(b.eventType) || new Date(b.date) - new Date(a.date);
      }

      return new Date(b.date) - new Date(a.date);
    });
  }, [filterBy, sortBy]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === carouselImages.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [carouselImages.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === carouselImages.length - 1 ? 0 : prevSlide + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? carouselImages.length - 1 : prevSlide - 1
    );
  };

  const handleReturnHome = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openLightbox = (image) => {
    setLightboxImage(image);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    document.body.style.overflow = "auto";
  };

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <div className="section-header">
          <h2>Our Impact Gallery</h2>
          <div className="underline"></div>
          <p className="section-description">
            See how Pramila Foundation is making a difference in communities through our various initiatives
          </p>
        </div>

        <div className="gallery-controls">
          <div className="control-group">
            <label htmlFor="sort-select">Sort by:</label>
            <select
              id="sort-select"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="control-select"
            >
              <option value="date">Date (Newest First)</option>
              <option value="title">Title (A-Z)</option>
              <option value="eventType">Event Type</option>
            </select>
          </div>
          <div className="control-group">
            <label htmlFor="filter-select">Filter by:</label>
            <select
              id="filter-select"
              value={filterBy}
              onChange={(e) => setFilterBy(e.target.value)}
              className="control-select"
            >
              <option value="all">All Events</option>
              <option value="education">Education</option>
              <option value="sports">Sports</option>
              <option value="environment">Environment</option>
              <option value="welfare">Social Welfare</option>
            </select>
          </div>
        </div>

        <div className="carousel">
          <div className="carousel-container">
            {carouselImages.map((image, index) => (
              <div
                key={image.title}
                className={`carousel-slide ${index === currentSlide ? "active" : ""}`}
                style={{
                  transform: `translateX(${100 * (index - currentSlide)}%)`,
                }}
              >
                <img
                  src={image.src}
                  alt={`Pramila Foundation Activity ${index + 1}`}
                />
              </div>
            ))}
          </div>

          <button className="carousel-button prev" onClick={prevSlide}>
            &#10094;
          </button>
          <button className="carousel-button next" onClick={nextSlide}>
            &#10095;
          </button>

          <div className="carousel-dots">
            {carouselImages.map((image, index) => (
              <span
                key={image.title}
                className={`dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => goToSlide(index)}
              ></span>
            ))}
          </div>
        </div>

        <div className="gallery-grid">
          {sortedImages.map((image) => (
            <div key={image.title} className="gallery-item">
              <div className="image-container">
                <img src={image.src} alt={image.title} />
              <div className="image-overlay">
                <div className="overlay-content">
                  <button
                    className="expand-btn"
                    onClick={() => openLightbox(image.src)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 3H21V9"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9 21H3V15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21 3L14 10"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3 21L10 14"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      View Full Size
                  </button>
                </div>
              </div>
            </div>
            </div>
          ))}
        </div>

        {lightboxImage && (
          <div className="lightbox-overlay" onClick={closeLightbox}>
            <div
              className="lightbox-container"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="lightbox-close" onClick={closeLightbox}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="lightbox-content">
                <img src={lightboxImage} alt="Gallery" />
              </div>
            </div>
          </div>
        )}

        <div className="home-button-container">
          <button className="home-button" onClick={handleReturnHome}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 22V12H15V22"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
}
